import styled from 'styled-components';
import { Link as LinkR } from 'react-router-dom';
import { Link as LinkS } from 'react-scroll';

export const Nav = styled.nav`
  background: #f3f1ea;
  height: 160px;
  padding-bottom: 10px;
  margin-top: -160px;

  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 10;

  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
  }

  @media screen and (max-width: 400px) {
    height: 80px;

    ${'' /* margin-top: -80px; */}
    margin-top: 0px;
  }
`;

export const NavBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 100%;
  align-items: center;
  ${'' /* height: 80px; */}
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1100px;
`;

export const NavBarIntro = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RightBlock = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-end;
  ${'' /* width: 100%; */}
`;

export const NavBarImg = styled.img`
  height: 108px;
  width: 100px;

  @media screen and (max-width: 400px) {
    height: 54px;
    width: 50px;
  }
`;

export const NavBarCity = styled.div`
  ${
    '' /* font-size:: 31px
line-height: 36px */
  }
  font-size: 24px;
  font-weight: 600;

  @media screen and (max-width: 500px) {
    display: none;
  }
`;

export const NavLogo = styled(LinkR)`
  color: #000000;
  justify-self: flex-start;
  cursor: pointer;
  font-size: 2rem;
  display: flex;
  align-items: center;
  margin: 0 24px;
  font-weight: bold;
  text-decoration: none;
`;

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 900px) {
    display: block;
    position: absolute;
    ${
      '' /* top: 0;
        right: 0; */
    }
    top: 45px;
    right: 10px;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #000;
  }

  @media screen and (max-width: 400px) {
    top: 5px;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;

  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  heigth: 80px;
`;

export const NavLinks = styled(LinkS)`
  color: #000;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;

  &.active {
    border-bottom: 3px solid #000;
    padding-bottom: 10px;
  }
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;
  margin-left: 10px;
  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const NavBtnLink = styled(LinkR)`
  color: #979692;
  font-size: 16px;
  outline: none;
  border: none;
  ${'' /* cursor: pointer; */}
  transition: all 0.2s easy-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s easy-in-out;
  }

  ::after {
    content: 'Скоро';
    left: -15px;
    top: -10px;
    position: relative;
    padding: 1px 6px;
    border-radius: 8px;
    background-color: #dfbfb1;
    color: #000;
    font-size: 13px;
    line-height: 22px;
  }
`;

export const Info = styled.div`
  grid-template-columns: 1fr 1fr 34px;
  grid-gap: 16px;
  display: grid;
  max-width: 520px;
  align-self: flex-end;
  @media screen and (max-width: 900px) {
    display: none;
  }
`;
export const InfoP = styled.p`
  line-height: 20px;
  font-weight: 600;
  font-size: 18px;
`;
export const InfoIcon = styled.svg`
  width: 31px;
  height: 34px;
`;
export const InfoPhone = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const NavBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px 0 5px;
`;

export const SocialMediaWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${'' /* margin: 0 10px; */}
  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const SocialMediaLink = styled.a`
  color: #000;
`;

export const InfoPhoneMobile = styled.div`
  display: none;
  @media screen and (max-width: 900px) {
    display: flex;
    flex-direction: column;
    margin-left: 20px;
    text-align: right;
  }
  @media screen and (max-width: 730px) {
    display: none;
  }
`;
